var _style, _path, _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAu(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#0052B4;}\n\t.st1{fill:#F0F0F0;}\n\t.st2{fill:#D80027;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M512,256c0,141.4-114.6,256-256,256S0,397.4,0,256C0,256.1,256,0,256,0C397.4,0,512,114.6,512,256z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M256,0C256,0,256,0,256,0L256,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M255.3,256h0.7c0-0.2,0-0.5,0-0.7C255.8,255.5,255.5,255.8,255.3,256z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M256,133.6c0-45,0-74.6,0-133.6h0C114.6,0,0,114.6,0,256h133.6v-75.2l75.2,75.2h46.5c0.2-0.2,0.5-0.5,0.7-0.7 c0-17.2,0-32.6,0-46.5l-75.2-75.2L256,133.6z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M129.5,33.4c-40,22.8-73.3,56.1-96.1,96.1V256h66.8V100.2v0H256c0-21.1,0-41.1,0-66.8L129.5,33.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M256,224.5l-91-91h-31.5c0,0,0,0,0,0L256,256h0C256,256,256,234.3,256,224.5L256,224.5z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M154.4,300.5l14.1,29.4l31.7-7.3L186,351.9l25.5,20.2l-31.8,7.2l0.1,32.6l-25.4-20.4L129,411.8l0.1-32.6 l-31.8-7.2l25.5-20.2l-14.2-29.3l31.7,7.3L154.4,300.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M383.3,356.2l7,14.7l15.9-3.7l-7.1,14.7l12.8,10.1l-15.9,3.6l0,16.3l-12.7-10.2l-12.7,10.2l0-16.3l-15.9-3.6 l12.8-10.1l-7.1-14.7l15.9,3.7L383.3,356.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M317.9,200.3l7,14.7l15.9-3.7l-7.1,14.7l12.8,10.1l-15.9,3.6l0,16.3l-12.7-10.2L305.2,256l0-16.3l-15.9-3.6 l12.8-10.1l-7.1-14.7l15.9,3.7L317.9,200.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M383.3,111.3l7,14.7l15.9-3.7l-7.1,14.7l12.8,10.1l-15.9,3.6l0,16.3l-12.7-10.2L370.6,167l0-16.3l-15.9-3.6 l12.8-10.1l-7.1-14.7l15.9,3.7L383.3,111.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M440.4,178.1l7,14.7l15.9-3.7l-7.1,14.7l12.8,10.1l-15.9,3.6l0,16.3l-12.7-10.2l-12.7,10.2l0-16.3l-15.9-3.6 l12.8-10.1l-7.1-14.7l15.9,3.7L440.4,178.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M399.5,256l5.5,17H423l-14.5,10.5l5.5,17L399.5,290l-14.5,10.5l5.5-17L376.1,273H394L399.5,256z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAu);
export default __webpack_public_path__ + "static/media/au.dfedc0cc75e0494cda3a09edcd48861a.svg";
export { ForwardRef as ReactComponent };